/**
 * @generated SignedSource<<d393eb58b70a9f5c5eae6ff8e9977103>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ClientCategorizationQuestionStyle = "DETAILED" | "INPUT_FIELD" | "NONE" | "SELECTOR" | "STATEMENT" | "WARNING";
export type ClientCategorizationQuestionType = "MULTI_PART" | "SINGLE_CHOICE" | "STATEMENT" | "WARNING";
export type ClientCategorizationQuestionsQuery$variables = Record<PropertyKey, never>;
export type ClientCategorizationQuestionsQuery$data = {
  readonly clientCategorizationQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answers: ReadonlyArray<{
          readonly answer: string | null | undefined;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly nestedQuestions: ReadonlyArray<{
            readonly answers: ReadonlyArray<{
              readonly answer: string;
              readonly description: string | null | undefined;
              readonly id: string;
              readonly nextItemId: string | null | undefined;
            }> | null | undefined;
            readonly id: string;
            readonly placeholder: string | null | undefined;
            readonly question: string | null | undefined;
            readonly style: ClientCategorizationQuestionStyle | null | undefined;
            readonly type: ClientCategorizationQuestionType;
          }> | null | undefined;
          readonly nextItemId: string | null | undefined;
        }> | null | undefined;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly instruction: string | null | undefined;
        readonly nextItemId: string | null | undefined;
        readonly parts: ReadonlyArray<{
          readonly answers: ReadonlyArray<{
            readonly answer: string;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly nestedQuestions: ReadonlyArray<{
              readonly answers: ReadonlyArray<{
                readonly answer: string;
                readonly description: string | null | undefined;
                readonly id: string;
                readonly nextItemId: string | null | undefined;
              }> | null | undefined;
              readonly description: string | null | undefined;
              readonly id: string;
              readonly placeholder: string | null | undefined;
              readonly question: string | null | undefined;
              readonly style: ClientCategorizationQuestionStyle | null | undefined;
              readonly type: ClientCategorizationQuestionType;
            }> | null | undefined;
            readonly nextItemId: string | null | undefined;
          }> | null | undefined;
          readonly id: string;
          readonly question: string | null | undefined;
          readonly style: ClientCategorizationQuestionStyle | null | undefined;
          readonly type: ClientCategorizationQuestionType;
        }> | null | undefined;
        readonly placeholder: string | null | undefined;
        readonly question: string | null | undefined;
        readonly style: ClientCategorizationQuestionStyle | null | undefined;
        readonly subtitle: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: ClientCategorizationQuestionType;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ClientCategorizationQuestionsQuery = {
  response: ClientCategorizationQuestionsQuery$data;
  variables: ClientCategorizationQuestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placeholder",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextItemId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientCategorizationNestedAnswer",
  "kind": "LinkedField",
  "name": "answers",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v7/*: any*/),
    (v2/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientCategorizationQuestionsConnection",
    "kind": "LinkedField",
    "name": "clientCategorizationQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientCategorizationQuestionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientCategorizationQuestion",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instruction",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientCategorizationAnswer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientCategorizationNestedQuestion",
                    "kind": "LinkedField",
                    "name": "nestedQuestions",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientCategorizationNestedQuestion",
                "kind": "LinkedField",
                "name": "parts",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientCategorizationNestedAnswer",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientCategorizationNestedQuestion",
                        "kind": "LinkedField",
                        "name": "nestedQuestions",
                        "plural": true,
                        "selections": [
                          (v0/*: any*/),
                          (v1/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientCategorizationQuestionsQuery",
    "selections": (v9/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClientCategorizationQuestionsQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "5b92c9f72baeb892c28bb0dfe2e91a08",
    "id": null,
    "metadata": {},
    "name": "ClientCategorizationQuestionsQuery",
    "operationKind": "query",
    "text": "query ClientCategorizationQuestionsQuery {\n  clientCategorizationQuestions {\n    edges {\n      node {\n        id\n        question\n        description\n        title\n        subtitle\n        instruction\n        placeholder\n        style\n        type\n        nextItemId\n        answers {\n          id\n          answer\n          description\n          nextItemId\n          nestedQuestions {\n            id\n            question\n            placeholder\n            style\n            type\n            answers {\n              id\n              answer\n              description\n              nextItemId\n            }\n          }\n        }\n        parts {\n          id\n          question\n          style\n          type\n          answers {\n            id\n            answer\n            description\n            nextItemId\n            nestedQuestions {\n              id\n              question\n              style\n              type\n              placeholder\n              description\n              answers {\n                id\n                answer\n                description\n                nextItemId\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "15160fafb70443eb205d20b16974908c";

export default node;
